// @flow

import './index.scss';
import * as React from 'react';
import { Range, useThumbOverlap } from 'react-range';
import formatAmount from 'utils/formatAmount';

type Props = {|
    rangeRef: Range | null,
    values: number[],
    index: number,
    max: number
|};

const ThumbLabel = ({ rangeRef, values, index, max }: Props): React.Node => {
    const [labelValue, labelStyle] = useThumbOverlap(
        rangeRef,
        values,
        index,
        1,
        ' - ',
        value => formatAmount(value, {
            decimal  : 0,
            currency : parseInt(value, 10) >= max ? '+' : ''
        })
    );

    return (
        <div className="ThumbLabel" data-label={index} style={labelStyle}>
            {(labelValue: any)}
        </div>
    );
};

export default ThumbLabel;
